/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type BioExamResult from "parog-web/models/bio-exam-result";
import styles from "./index.module.css";

interface Signature {
  Args: {
    bioExamResultChangeset: BioExamResult;
    shouldBeEmphasized: boolean;
    index: number;
    source: string;
  };
}
export default class extends Component<Signature> {
  styles = styles;
}
